import React, { useEffect, useRef, useState } from 'react'
import './check-in-out-content.styles.scss';
import { useSelector } from 'react-redux';
import { UseCloudFunction } from '../../utils/firebase.utils';
import UIkit, { data } from 'uikit';
import { useNavigate } from 'react-router-dom';
import { obfuscateString } from '../../utils/obfuscation';
import { Multi, Select, Textarea } from '../inputs/inputs.component';

const CheckInOutContent = ({
  evalData,
  formContent,
}) => {

  const screenSize = useSelector(state => state.listsData.screenSize);
  const userProfile = useSelector(state => state.userData.userProfile);
  const [formData, setFormData] = useState({})
  const [dataFetched, setDataFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ req ] = useState([
    'fName', 'lName', 'email', 'iein', 'school', 'dist'
  ])
  const dataRef = useRef({});
  const navigate = useNavigate();

  useEffect(() => {
    if (!evalData) return;
    getUserData();
  }, [evalData])

  async function getUserData() {
    const u = await UseCloudFunction(
      'getUserDataFromNFE',
      {
        'userProfile': userProfile
      })
    // console.log(u);
    if (u.error) {
      UIkit.modal.alert('Something went wrong retrieving your information. Please fill in the form below.');
      setDataFetched(true);
    }
    const userData = u.userData[0];
    dataRef.current = {
      'fName': userData.ind_first_name,
      'lName': userData.ind_last_name,
      'email': userData.cst_eml_address_dn,
      'iein': userData.ind_ein_number_ext ?? '',
      'school': userData.v01_primary_org_name ?? '',
      'dist': userData.v01_ultimate_org_name ?? ''
    }
    setFormData(dataRef.current);
    setDataFetched(true);
  }

  function saveData(key, value) {
    dataRef.current = {
      ...dataRef.current,
      ...{ [key]: value }
    }
    setFormData(dataRef.current);
  }

  function handleTextChange(key, value) {
    // console.log(stateRef.current)
    dataRef.current = { ...dataRef.current, ...{ [key]: value } };
    setFormData(dataRef.current);
  }

  function handleMultipleChange(key, value) {
    // console.log(key, value)
    dataRef.current = { ...dataRef.current, ...{ [key]: (value) ? 1 : 0 } };
    setFormData(dataRef.current);
  }

  function handleSelectChange(key, value) {
    // console.log(key, value)
    dataRef.current = { ...dataRef.current, ...{ [key]: Number(value) } };
    setFormData(dataRef.current);
  }

  async function handleSubmit() {
    const tempData = { ...dataRef.current };
    let requiredComplete = {};
    for (let f of formContent) {
      if (f.required == 'true') {
        requiredComplete[f.key] = false;
        if (f.type == 'multiple' || f.type == 'select') {
          for (let d of Object.keys(tempData)) {
            if (d.includes(f.key) && tempData[d] > 0) {
              requiredComplete[f.key] = true
            }
          }
        }
      }
    }
    if (evalData.cpdu && !tempData.date) {
      // requiredComplete.date = false
    }
    // console.log(requiredComplete)
    let formComplete = true;
    for (let c of Object.values(requiredComplete)) {
      if (!c) {
        formComplete = false
      }
    }
    for (let r of req) {
      if (!tempData[r]) {
        formComplete = false
      }
    }
    console.log(requiredComplete, formComplete)
    if (!requiredComplete || !formComplete) {
      UIkit.modal.alert('Please complete the required parts of the evaluation before submitting.')
      return;
    }
    // console.log(tempData);
    // for (let r of req) {
    //   if (!tempData[r]) {
    //     UIkit.modal.alert('Please complete the entire form before submitting.');
    //     return;
    //   }
    // }
    if (isNaN(Number(tempData.iein))) {
      UIkit.modal.alert('Please enter a valid IEIN number (numbers only).');
      return;
    }
    const approve = await UIkit.modal.confirm('Are you sure you want to check in/out for this event?', { labels: { ok: 'Yes', cancel: 'No' } })
      .then(() => true, () => false);
    if (!approve) {
      return;
    }

    setLoading(true);
    tempData.cst_key = userProfile.id;
    tempData.evalId = evalData.id;
    tempData.evalItemId = evalData.itemId;
    tempData.evalSource = evalData.source;
    tempData.evalType = evalData.type;
    console.log(tempData);

    const res = await UseCloudFunction(
      'saveUserEval',
      {
        'formData': tempData,
        'evalData': evalData,
        'platform': evalData.platform,
        'customEval': evalData.customEval,
        'userProfile': userProfile,
        'containsEval': (formContent.length > 0) ? true : false
      }
    )
    console.log(res);
    setLoading(false);
    if (res.error) {
      UIkit.modal.alert('Something went wrong saving your information. Please try again.');
      return;
    }
    UIkit.modal.alert('You have successfully submitted your status for this event. Thank you!')
      .then(() => {
        if (evalData.cpdu) {
          const urlString = obfuscateString(
            JSON.stringify({
              'evalId': tempData.evalId,
              'cstKey': userProfile.id
            })
          );
          window.open(
            `${window.location.origin}/print/${urlString}`,
            '_blank',
            'noopener,noreferrer'
          )
        }
        navigate('/home')
      });
  }

  return (
    <div className={`sign-in-out-content ${screenSize}`}>
      {
        (evalData && dataFetched)
          ?
          <div className={screenSize === 'mobile' ? 'mobile' : 'g-card'}>
            <h3>
              <span className='meta'>Event:</span>
              <br />
              <b>{evalData.item.title}</b>
            </h3>
            <hr />
            <p>Click the button below to sign in for the event listed above. Make sure your information is accurate before submitting.</p>
            {
              (formContent.length > 0) &&
              <p><b>NOTE:</b> The evaluation portion will be saved separately and will not be associated with your registration information.</p>
            }
            <div className='meta'>All fields required unless otherwise noted.</div>
            <div className='field'>
              <label>First Name</label>
              <input
                className="uk-input"
                type='text'
                value={formData.fName ?? ''}
                onChange={e => saveData('fName', e.target.value)}
              />
            </div>
            <div className="g-space-1"></div>
            <div className='field'>
              <label>Last Name</label>
              <input
                className="uk-input"
                type='text'
                value={formData.lName ?? ''}
                onChange={e => saveData('lName', e.target.value)}
              />
            </div>
            <div className="g-space-1"></div>
            <div className='field'>
              <label>Email Address</label>
              <input
                className="uk-input"
                type='text'
                value={formData.email ?? ''}
                onChange={e => saveData('email', e.target.value)}
              />
            </div>
            <div className="g-space-1"></div>
            <div className='field'>
              <label>IL Educator ID Number (IEIN)</label>
              <input
                className="uk-input"
                type='text'
                value={formData.iein ?? ''}
                onChange={e => saveData('iein', e.target.value)}
              />
            </div>
            <div className="g-space-1"></div>
            <div className='field'>
              <label>School</label>
              <input
                className="uk-input"
                type='text'
                value={formData.school ?? ''}
                onChange={e => saveData('school', e.target.value)}
              />
            </div>
            <div className="g-space-1"></div>
            <div className='field'>
              <label>District/Organization</label>
              <input
                className="uk-input"
                type='text'
                value={formData.dist ?? ''}
                onChange={e => saveData('dist', e.target.value)}
              />
            </div>
            <div className="g-space-2"></div>

            {
              (formContent && formContent.length > 0) &&
              formContent.map(sec => {
                
                
                return (
                (sec.type == 'multiple')
                  ?
                  <Multi
                    key={sec.key}
                    u_key={sec.key}
                    label={sec.title}
                    options={Object.values(sec.content)}
                    handleChange={handleMultipleChange}
                    req={sec.required}
                  />
                  :
                  (sec.type == 'select')
                    ?
                    <div key={sec.key}>
                      <Select

                        u_key={sec.key}
                        label={sec.title}
                        options={Object.values(sec.content)}
                        cls='uk-form-width-medium'
                        handleChange={handleSelectChange}
                        req={sec.required}
                      />

                    </div>
                    :
                    (sec.type == 'title')
                      ?
                      <div key={sec.key} className='uk-margin'>
                        <div className='form-section-title'>
                          {sec.title}
                        </div>
                        <div className='form-section-content'>
                          {sec.content}
                        </div>
                      </div>
                      :
                      (sec.type == 'textarea')
                        ?
                        <div key={sec.key}>
                          <Textarea
                            u_key={sec.key}
                            label={sec.title}
                            handleChange={handleTextChange}
                            req={sec.required}
                          />
                        </div>
                        : ''
                )}
              )

            }

            <div className='buttons'>
              {
                (loading)
                  ?
                  <button className="g-button" disabled>
                    Processing...
                  </button>
                  :
                  <button
                    className="g-button submit-button"
                    onClick={() => handleSubmit()}
                  >
                    Submit Data
                  </button>
              }
            </div>
          </div>
          :
          <div >LOADING...</div>
      }
    </div>
  )
}

export default CheckInOutContent